import { Box, Checkbox } from "@mui/material";
import { useBoundStore } from "useStore";
import { useShallow } from "zustand/react/shallow";

export default function AdsCustomCheckbox({ row }) {
  const isChecked = useBoundStore(
    useShallow((state) => state.adsSelectionModel.includes(row.itemId)),
  );
  const isEdited = useBoundStore(
    useShallow((state) => !!state.adsEditedRows[row.itemId]),
  );
  const toggleAdsSelection = useBoundStore(
    (state) => state.toggleAdsSelection,
  );

  return (
    <Box>
      <Checkbox
        checked={isChecked}
        onChange={() => toggleAdsSelection(row.itemId)}
        disabled={!isEdited}
        sx={{
          p: 0,
          "&.Mui-checked": { color: "#002878" },
          "&.Mui-disabled": { color: "#0000001F" },
        }}
      />
    </Box>
  );
}
